import { ProductLine } from '../types/catalog';

export const productLines: ProductLine[] = [
  {
    id: 'zero-metal',
    name: 'Zero Metal',
    subtitle: 'Purificação e Proteção',
    description:
      'Kit ideal para purificar e proteger os fios de impurezas e danos. Remove metais, cloro, resíduos e acúmulos de produtos, garantindo cabelos saudáveis e protegidos.',
    images: ['/images/Zero Metal.webp', '/images/Zero Metal_1.webp'],
    products: [
      {
        name: 'Shampoo Home Care Zero Metal 300ml',
        description: 'Limpeza purificante para manutenção diária no salão e em casa.',
        priceCents: 4766,
      },
      {
        name: 'Máscara Home Care Zero Metal 300ml',
        description: 'Reposição de nutrientes e selagem do brilho para uso home care.',
        priceCents: 5266,
      },
      {
        name: 'Kit Home Care Zero Metal',
        description: 'Combo com shampoo e máscara para manter os fios purificados e protegidos em casa.',
        priceCents: 7900,
        isKit: true,
        includes: ['Shampoo Home Care Zero Metal 300ml', 'Máscara Home Care Zero Metal 300ml'],
      },
      {
        name: 'Shampoo Professional Zero Metal 1L',
        description: 'Preparação profissional com alta performance para tratamentos.',
        priceCents: 10933,
      },
      {
        name: 'Máscara Professional Zero Metal 1L',
        description: 'Reconstrução profunda com resultado de salão para fios desmineralizados.',
        priceCents: 14800,
      },
      {
        name: 'Kit Professional Zero Metal',
        description: 'Kit profissional com shampoo e máscara para uma purificação completa no salão.',
        priceCents: 29800,
        isKit: true,
        includes: ['Shampoo Professional Zero Metal 1L', 'Máscara Professional Zero Metal 1L'],
      },
    ],
  },
  {
    id: 'resistence-europa',
    name: 'Resistence Europa',
    subtitle: 'Reparação Profunda',
    description:
      'Solução ideal para cabelos quebradiços, quimicamente tratados, secos e opacos. Repõe aminoácidos essenciais e devolve força, brilho e saúde aos fios.',
    images: ['/images/Resistence Europa.webp', '/images/Resistence Europa_1.webp'],
    products: [
      {
        name: 'Shampoo Home Care Resistence 300ml',
        description: 'Limpeza que repõe aminoácidos essenciais, ideal para manutenção diária.',
        priceCents: 4766,
      },
      {
        name: 'Máscara Home Care Resistence 300ml',
        description: 'Tratamento hidratante que fortalece e sela o fio.',
        priceCents: 5266,
      },
      {
        name: 'Leave-in Resistence 300ml',
        description: 'Finalizador nutritivo com proteção térmica e anti-quebra.',
        priceCents: 6500,
      },
      {
        name: 'Kit Home Care Resistence',
        description: 'Shampoo, máscara e leave-in para um cronograma completo de reparação em casa.',
        priceCents: 11500,
        isKit: true,
        includes: [
          'Shampoo Home Care Resistence 300ml',
          'Máscara Home Care Resistence 300ml',
          'Leave-in Resistence 300ml',
        ],
      },
      {
        name: 'Shampoo Professional Resistence 1L',
        description: 'Limpeza profissional intensa com alto poder de reconstrução.',
        priceCents: 10633,
      },
      {
        name: 'Máscara Professional Resistence 1kg',
        description: 'Reconstrução poderosa para cabelos extremamente danificados.',
        priceCents: 13500,
      },
      {
        name: 'Leave-in Resistence Professional 300ml',
        description: 'Selagem e proteção com performance profissional.',
        priceCents: 6500,
      },
      {
        name: 'Kit Professional Resistence',
        description: 'Combo profissional com shampoo, máscara e leave-in para reparação avançada.',
        priceCents: 29900,
        isKit: true,
        includes: [
          'Shampoo Professional Resistence 1L',
          'Máscara Professional Resistence 1kg',
          'Leave-in Resistence 300ml',
        ],
      },
    ],
  },
  {
    id: 'intensive',
    name: 'Intensive',
    subtitle: 'Reposição de Massa',
    description:
      'Linha completa para cabelos danificados. Promove reposição de massa, combate à porosidade e restauração profunda da estrutura capilar.',
    images: ['/images/Intensive.webp', '/images/Intensive_1.webp', '/images/Intensive_Keratina.webp', '/images/Intensive_Serum.webp', '/images/Intensive_Spray.webp'],
    products: [
      {
        name: 'Shampoo Home Care Intensive 300ml',
        description: 'Limpeza suave que inicia a reposição de massa e prepara o fio para tratamentos.',
        priceCents: 4166,
      },
      {
        name: 'Condicionador Home Care Intensive 300ml',
        description: 'Condicionamento profundo com ativos reconstrutores para uso diário.',
        priceCents: 4666,
      },
      {
        name: 'Máscara Home Care Intensive 300ml',
        description: 'Tratamento semanal que repõe massa e sela cutículas.',
        priceCents: 5166,
      },
      {
        name: 'Kit Home Care Intensive',
        description: 'Conjunto home care com shampoo, condicionador e máscara para reposição de massa.',
        priceCents: 11000,
        isKit: true,
        includes: [
          'Shampoo Home Care Intensive 300ml',
          'Condicionador Home Care Intensive 300ml',
          'Máscara Home Care Intensive 300ml',
        ],
      },
      {
        name: 'Shampoo Professional Intensive 1L',
        description: 'Limpeza profissional de alto desempenho com reposição imediata de massa.',
        priceCents: 9166,
      },
      {
        name: 'Condicionador Professional Intensive 1L',
        description: 'Condicionamento profissional que restaura elasticidade e brilho.',
        priceCents: 9666,
      },
      {
        name: 'Máscara Professional Intensive 1kg',
        description: 'Reconstrução profunda com blend tecnológico para salões.',
        priceCents: 12800,
      },
      {
        name: 'Kit Professional Intensive',
        description: 'Combo profissional com shampoo, condicionador e máscara para restauração completa.',
        priceCents: 26900,
        isKit: true,
        includes: [
          'Shampoo Professional Intensive 1L',
          'Condicionador Professional Intensive 1L',
          'Máscara Professional Intensive 1kg',
        ],
      },
      {
        name: 'Spray Finalizador Intensive 10em1 200ml',
        description: 'Finalizador multifuncional com 10 benefícios imediatos.',
        priceCents: 5500,
      },
      {
        name: 'Sérum Rose Intensive 30ml',
        description: 'Sérum finalizador luxuoso com óleos de Marula, Jojoba e Camélia.',
        priceCents: 6500,
      },
      {
        name: 'Keratina Intensive 200ml',
        description: 'Keratina líquida vegetal para reposição de massa e fortalecimento.',
        priceCents: 6990,
      },
    ],
  },
  {
    id: 'color',
    name: 'Color Professional',
    subtitle: 'Descoloração e Coloração',
    description:
      'Garante clareamento preciso preservando a integridade da fibra capilar. Proteção, hidratação e resultados impecáveis.',
    images: ['/images/Color Professional.webp', '/images/Color Professional_1.webp'],
    products: [
      {
        name: 'Pó Descolorante Color Professional 500g',
        description: 'Pó dust free com plex, colágeno e blend de ômegas para clareamento seguro.',
        priceCents: 9800,
      },
      {
        name: 'Emulsão Oxidante 20 Volumes 900ml',
        description: 'Ox 20v estabilizada que protege e hidrata durante a descoloração.',
        priceCents: 3990,
      },
      {
        name: 'Emulsão Oxidante 30 Volumes 900ml',
        description: 'Ox 30v com performance profissional e ação condicionante.',
        priceCents: 3990,
      },
      {
        name: 'Emulsão Oxidante 40 Volumes 900ml',
        description: 'Ox 40v para clareamentos altos com preservação da fibra.',
        priceCents: 3990,
      },
    ],
  },
  {
    id: 'nanoplastia',
    name: 'Nanoplastia',
    subtitle: 'Realinhamento Capilar',
    description:
      'Combina limpeza profunda com realinhamento eficaz. Fortalece a fibra capilar, garante elasticidade e previne quebra.',
    images: ['/images/Nanoplastia.webp', '/images/Nanoplastia_1.webp'],
    products: [
      {
        name: 'Realinhamento Perfect Active Liss 1kg',
        description: 'Tratamento de nanoplastia orgânica para realinhamento intenso e brilho espelhado.',
        priceCents: 34500,
      },
      {
        name: 'Shampoo Deep Clean 1kg',
        description: 'Limpeza profunda que prepara os fios para o realinhamento.',
        priceCents: 7000,
      },
      {
        name: 'Kit Nanoplastia Active Liss',
        description: 'Combo com realinhamento e shampoo deep clean para resultado profissional completo.',
        priceCents: 38500,
        isKit: true,
        includes: ['Realinhamento Perfect Active Liss 1kg', 'Shampoo Deep Clean 1kg'],
      },
      {
        name: 'Realinhamento Perfect Active Liss Blond 1kg',
        description: 'Fórmula blond com pigmentos violeta para neutralizar tons alaranjados.',
        priceCents: 35500,
      },
      {
        name: 'Shampoo Deep Clean Blond 1kg',
        description: 'Shampoo de limpeza profunda com ação matizadora para fios loiros.',
        priceCents: 7000,
      },
      {
        name: 'Kit Nanoplastia Active Liss Blond',
        description: 'Kit blond com realinhamento e shampoo matizador para loiros alinhados.',
        priceCents: 39500,
        isKit: true,
        includes: ['Realinhamento Perfect Active Liss Blond 1kg', 'Shampoo Deep Clean Blond 1kg'],
      },
    ],
  },
  {
    id: 'botox',
    name: 'Botox Extremeliss',
    subtitle: 'Reconstrução Intensiva',
    description:
      'Para cabelos mais lisos, fortes e revitalizados. Redução de volume, alinhamento perfeito e resultados duradouros.',
    images: ['/images/Botox Extremeliss.webp', '/images/Botox Extremeliss_1.webp'],
    products: [
      {
        name: 'Botox Blond 1kg',
        description: 'Reconstrutor ultra nutritivo com efeito blond para alinhamento e redução de volume.',
        priceCents: 17000,
      },
    ],
  },
  {
    id: 'healing',
    name: 'Healing Parfum',
    subtitle: 'Fragrância Exclusiva',
    description:
      'Uma fragrância marcante com notas suaves. Brilho intenso, maciez irresistível e toque de luxo em cada fio.',
    images: ['/images/Healing Parfum.webp'],
    products: [
      {
        name: 'Perfume Healing Rose',
        description: 'Fragrância exclusiva com notas sofisticadas e fixação prolongada.',
        priceCents: 11000,
      },
      { name: 'Healing Gold', description: 'Notas suaves e luxuosas' },
    ],
  },
];
